<template>
    <div class="layout-people">
        <slot name="header">
            <div class="uk-section uk-section-medium uk-text-center uk-background-muted page-header">
              <div class="uk-light uk-container uk-container-small uk-text-center">

                  <router-link :to="parent.link" v-if="parent" class="text-green"><label>{{parent.menuTitle}}</label></router-link>
                  <h1 class="uk-margin-small-top">{{page.title}}</h1>

                  <slot name="summary">
                      <p class="uk-text-lead" v-if="page.summary">{{page.summary}}</p>
                  </slot>

                  <form class="uk-flex uk-flex-center" uk-grid>
                      <div class="uk-width-2-3@m">
                          <input class="uk-input" v-model="search" placeholder="Search by name..." />
                      </div>
                  </form>
              </div>
            </div>
        </slot>
        <div class="uk-section uk-background-white uk-section-medium" v-if="people && people.length">
            <div class="uk-container uk-container-large">

                <div v-if="!search && maxYear">
                    <h2><b>{{maxYear}}</b> LMC Fellows</h2>

                    <div class="uk-grid uk-child-width-1-2@s uk-child-width-1-3@m uk-child-width-1-4@l" uk-grid uk-height-match="target: .summary">
                        <div v-for="child in recentPeople" :key="child.urlSegment">
                            <PersonCard :person="child" :hideLabel="true" />
                        </div>
                    </div>

                    <h2 class="uk-margin-large-top">LMC Fellowship <b>Alumni</b></h2>
                </div>

                <div class="uk-grid uk-child-width-1-2@s uk-child-width-1-3@m uk-child-width-1-4@l" uk-grid uk-height-match="target: .summary">
                    <div v-for="child in people" :key="child.urlSegment">
                        <PersonCard :person="child" :hideLabel="true" />
                    </div>
                </div>

            </div>
        </div>

        <div class="uk-padding-large uk-background-white uk-text-center" v-else >
            <i class="uk-margin-small-right" uk-spinner></i> Loading <b>LMC Fellows</b>...
        </div>

        <Testimonials :testimonials="(page && page.testimonialsArray) ? JSON.parse(page.testimonialsArray, true) : false" />
    </div>
</template>
<script>
import PersonCard from '../people/PersonCard.vue'
import gql from 'graphql-tag'
import _ from 'lodash'

// GraphQL query
const readOnePageQuery = gql`
    query($url: String!, $limit: Int!, $offset: Int!) {
      readOnePage(filter: { fullPath: { eq: $url }}){
        subpages(limit: $limit, offset: $offset) {
            edges {
                node {
                    classname
                    menuTitle
                    title
                    subtitle
                    link
                    image {
                        smallSquare
                        mediumSquare
                    }
                }
            }
        }
      }
    }
`

export default {
    props: ['page', 'parent'],
    data() {
        return {
            pageSize: 50,
            pageNumber: 0,
            allPeople: [],
            maxYear: undefined,
            search: ''
            // loading: false
        }
    },
    components: {
        PersonCard
    },
    watch: {
        '$route' (to, from) {
            this.pageNumber = 0
            this.allPeople = []
        }
    },
    apollo: {
        readOnePage: {
            query: readOnePageQuery,
            variables() {
                return {
                    url: this.$route.path,
                    limit: this.pageSize,
                    offset: this.pageNumber * this.pageSize
                }
            },
            // manual: true,
            update(data) {
                // if (!loading) {

                    if(!!data.readOnePage) {
                        let people = _.map(data.readOnePage.subpages.edges, "node")

                        this.allPeople = this.allPeople.concat(people)

                        if(people.length == this.pageSize) {
                            this.pageNumber++
                        }
                        else {
                            this.maxYear = _.max(_.map(this.allPeople, (o) => { return o.Subtitle.split(' ')[0] }))
                        }

                    }
                // }
                // this.loading = loading
            },
            loadingKey: 'loading'
        }
    },
    computed: {
        recentPeople() {
            return _.filter(this.allPeople, (o) => { return o.Subtitle.includes(this.maxYear) })
        },
        people() {
            if(!this.search && this.maxYear) {
                return _.filter(this.allPeople, (o) => { return !o.Subtitle.includes(this.maxYear) })
            }
            else {
                return _.filter(this.allPeople, (e) => {
                    return _.includes((e.title).toLowerCase(), this.search.toLowerCase())
                })
            }
        }
    }
}
</script>
